<template>
  <div id="katalog">
    <div style="width: 80%">
      <v-card elevation="10" class="katalog-card rounded-xl">
        <div class="menu-katalog" style="width: 100%">
          <div class="px-10 py-5 d-flex justify-start align-center">
            <div>
              <v-avatar color="primary" size="50">
                <v-img
                  contain
                  lazy-src="../../assets/img/logo-teman-bakat.png"
                  max-height="150"
                  max-width="250"
                  src="../../assets/img/logo-teman-bakat.png"
                ></v-img>
              </v-avatar>
            </div>
            <div class="item-menu-katalog ml-5">
              <a
                href="https://temanbakat.id"
                style="color: black; text-decoration: none"
                >Beranda</a
              >
            </div>
            <div class="item-menu-katalog ml-5" @click="toPenjurusan">
              Cari Jurusan
            </div>
          </div>
        </div>
        <div v-if="!isDownload" class="d-flex justify-start align-center">
          <div
            v-if="!isDownload"
            class="download py-12 px-12 desc"
            style="width: 80%"
          >
            <div class="mb-5 wrapp-silakan">
              <span class="silakan">Silakan</span><br />
              <span class="katalog">untuk mengunduh katalog</span> <br /><span
                class="penjurusan-tb"
                >Penjurusan Teman Bakat</span
              ><br />
              <span class="dibawah">di bawah ini</span>
            </div>
            <div class="wrap-download">
              <v-btn
                @click="
                  download(
                    `https://nos.wjv-1.neo.id/temanbakat/penjurusan/katalog/penjurusan_katalog.pdf`
                  )
                "
                color="#450073"
                dark
                elevation="2"
                class="text-capitalize rounded-lg"
                height="50"
                >Unduh Katalog</v-btn
              >
            </div>
          </div>
        </div>
        <div v-if="isDownload" class="d-flex justify-center align-center">
          <div style="width: 80%" class="pa-12 desc">
            <p
              class="terimakasih"
              style="font-weight: 800; font-size: 72px; line-height: 87.77px"
            >
              Terima <span style="color: #450073">Kasih</span>
            </p>
            <p
              class="mengunduh"
              style="font-weight: 400; font-size: 36px; line-height: 28px"
            >
              Telah mengunduh katalog
            </p>
            <p
              class="penjurusan"
              style="
                font-weight: 700;
                font-size: 36px;
                line-height: 28px;
                color: #450073;
              "
            >
              Penjurusan Teman Bakat
            </p>
            <div v-if="isDownload">
              <p class="dialihkan">
                Anda akan dialihkan langsung ke
                <span style="font-weight: bold; text-decoration: underline"
                  >temanbakat.id/penjurusan</span
                >
                dalam {{ timeleft }} detik...
              </p>
            </div>
          </div>
          <div style="width: 20%"></div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeleft: 0,
      isDownload: false,
    };
  },
  name: "penjurusan-katalog",
  methods: {
    countdown() {
      let vm = this;
      let timeleft = 6;
      let timer = setInterval(function () {
        timeleft--;
        vm.timeleft = timeleft;
        if (timeleft === 0) {
          vm.$router.push("/penjurusan");
          clearInterval(timer);
        }
      }, 1000);
    },
    download(uri) {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = uri;
      a.click();
      this.isDownload = true;
      this.countdown();
    },
    toPenjurusan() {
      let vm = this;
      vm.$router.push("/penjurusan");
    },
  },
};
</script>

<style>
#katalog {
  background-color: #edeaf4;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-katalog {
  background-image: url("../../assets/img/penjurusan/asset1a.png");
}
.item-menu-katalog {
  cursor: pointer;
}
.katalog-card {
  background-image: url("../../assets/img/penjurusan/asset-solo.png");
  background-position: bottom right;
  background-size: 300;
}
.silakan {
  font-weight: 800;
  font-size: 72px;
  color: #450073;
}
.penjurusan-tb {
  font-size: 36px;
  font-weight: bold;
  color: #450073;
}
.katalog {
  font-size: 36px;
}
.dibawah {
  font-size: 36px;
}
@media (max-width: 576px) {
  #katalog {
    height: 100%;
    padding: 20px 0px 20px 0px;
  }

  .katalog-card {
    height: 90vh;
  }

  .desc {
    width: 100% !important;
    padding: 0px !important;
  }

  .menu-katalog {
    display: none !important;
  }

  .terimakasih {
    font-size: 25px !important;
    line-height: 85% !important;
  }

  .mengunduh {
    font-size: 15px !important;
    line-height: 95% !important;
  }

  .penjurusan {
    font-size: 15px !important;
    line-height: 95% !important;
    margin-top: -5%;
  }

  .dialihkan {
    font-size: 15px !important;
  }

  .silakan {
    font-weight: 800;
    font-size: 42px;
    color: #450073;
  }
  .penjurusan-tb {
    font-size: 16px;
    font-weight: bold;
    color: #450073;
  }
  .katalog {
    font-size: 16px;
  }
  .dibawah {
    font-size: 16px;
  }
}
</style>
